module.exports = __webpack_public_path__ + "img/cert5.7c751888.png";